import { createTheme } from '@mui/material/styles';

// Brand colors
const VISMA_COLORS = {
    BLACK: '#252626',
    LIGHT_GREY: '#f0f2f5',
    MEDIUM_GREY: '#c1c3c5',
    RED: '#D93644',
    GREEN: '#4d8400',
    LIGHT_ORANGE: '#ffeacc',
    DARK_ORANGE: '#d76500',
    ORANGE_TEXT: '#b35300',
};

const WILMA_COLORS = {
    WHITE: '#FFFFFF',
    DARK_BLUE: '#003366',
    MEDIUM_AZURE: '#0099CC',
    AZURE: '#0071bd',
    LIGHT_CYAN: '#2DCCD3',
    DARK_TURQUOISE: '#008299',
    LIGHT_YELLOW: '#FFE552',
    YELLOW: '#FFD200',
};

export const theme = createTheme({
    palette: {
        primary: {
            light: WILMA_COLORS.MEDIUM_AZURE,
            main: WILMA_COLORS.AZURE,
            dark: VISMA_COLORS.BLACK,
            contrastText: WILMA_COLORS.WHITE,
        },
        secondary: {
            light: WILMA_COLORS.LIGHT_CYAN,
            main: WILMA_COLORS.WHITE,
            dark: WILMA_COLORS.DARK_TURQUOISE,
            contrastText: WILMA_COLORS.DARK_BLUE,
        },
        background: {
            default: VISMA_COLORS.LIGHT_GREY,
            paper: WILMA_COLORS.WHITE,
        },
        error: {
            main: VISMA_COLORS.RED,
            contrastText: WILMA_COLORS.WHITE,
        },
        warning: {
            main: VISMA_COLORS.LIGHT_ORANGE,
            dark: VISMA_COLORS.DARK_ORANGE,
            contrastText: VISMA_COLORS.ORANGE_TEXT,
        },
        info: {
            light: WILMA_COLORS.LIGHT_YELLOW,
            main: VISMA_COLORS.BLACK,
            dark: WILMA_COLORS.YELLOW,
            contrastText: WILMA_COLORS.DARK_BLUE,
        },
        success: {
            main: VISMA_COLORS.GREEN,
            contrastText: WILMA_COLORS.WHITE,
        },
        action: {
            disabled: VISMA_COLORS.MEDIUM_GREY,
        },
    },
    components: {
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    fontSize: '21px',
                },
                fontSizeSmall: {
                    fontSize: '16px',
                },
                fontSizeLarge: {
                    fontSize: '24px',
                },
            },
        },
    },
});
